export default {
  common: {
    actions: "Actions",
    author: "Author",
    cancel: "Cancel",
    create: "Create",
    delete: "Delete",
    edit: "Edit",
    legend: "Legend",
    referenceId: "Reference Id",
    paths: "Paths",
    save: "Save",
    title: "Title",
    type: "Type",
    updated: "Updated",
    yes: "Yes",
    practices: "Practices",
    practice: "Practice"
  },
  header: {
    authorization: "Authorization",
    contentTypeKey: "Content-Type",
    contentTypeValue: "application/json"
  },
  dialog: {
    unAuthorizedToken: {
      title: "Session Expired",
      msg:
        "Your session has expired. Would you like to be redirected to the login page?",
      type: "Warning"
    },
    delete: {
      employer: {
        title: "Delete Employer!",
        msg: "Are you sure that you want to delete this employer?"
      }
    },
    noPermission: {
      title: "Permission Denied",
      msg: "You do not currently have permission to perform this action.",
      type: "Warning"
    },
    program: {
      add: {
        title: "Assign Client",
        msg: "Are you sure that you want to assign this client to program?"
      },
      remove: {
        title: "Remove Client",
        msg: "Are you sure that you want to remove this client from program?"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/message.js